import store from '@/state/store'
let fields = [
  {
    key: 'doorOpenedOn',
    label: 'report.fields.doorOpen',
    header: 'doorOpenedOn',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'doorClosedOn',
    label: 'report.fields.doorClose',
    header: 'doorClosedOn',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 10,
  },
  {
    key: 'doorSensor',
    label: 'report.fields.doorCensor',
    header: 'doorSensor',
    filter: false,
    width: 10,
  },
  {
    key: 'duration',
    label: 'report.fields.doorOpenDuration',
    header: 'duration',
    filter: false,
    width: 10,
  },
]
if (store.getters['identity/hasAccess'](['door_geofence_column:read'])) {
  fields.splice(6, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}
export default fields
